/* 🛒 IAS CART-SLIM (polish wave 2, 09-28) — the Section Store cart drawer's payment wall
   (19 marks, 3 rows, ~107px) crowds the contents at phone width. Its config lives in the
   app dashboard (no theme setting), and it renders in an OPEN shadow root, so page CSS
   can't reach it — this tiny observer keeps the wall to the 5 marks US buyers actually
   look for. Badges row is already one line and stays. Remove this file to restore all 19. */
(function(){
  var KEEP=/visa|master|american_express|apple_pay|shopify_pay/;
  function slim(sr){
    sr.querySelectorAll('.cart-payment-icons .cart-payment-icon img').forEach(function(img){
      var li=img.closest('li'); if(!li) return;
      var show=KEEP.test(img.src||'');
      if((li.style.display==='none')!==!show) li.style.display=show?'':'none';
    });
  }
  var tries=0;
  function hook(){
    var host=document.querySelector('section-store--cart-block');
    if(!host||!host.shadowRoot){ if(tries++<40) setTimeout(hook,700); return; }
    var sr=host.shadowRoot;
    slim(sr);
    new MutationObserver(function(){ slim(sr); }).observe(sr,{childList:true,subtree:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',hook); else hook();
})();
